import { colors } from "../dark-hero/colors";

export const HERO_BG = "#080808";

export const REVEAL = {
  initial: { opacity: 0, y: 28, filter: "blur(10px)" },
  whileInView: { opacity: 1, y: 0, filter: "blur(0px)" },
  viewport: { once: true, amount: 0.25 },
};

export const SECTION_SX = {
  position: "relative",
  paddingTop: { xs: "4rem", md: "6rem" },
  paddingBottom: { xs: "4rem", md: "6rem" },
  px: { xs: 2, md: 4 },
  backgroundColor: HERO_BG,
};

export const LABEL_SX = {
  display: "flex",
  alignItems: "center",
  gap: "0.8rem",
  mb: 1.5,
  fontSize: "0.65rem",
  fontWeight: 600,
  letterSpacing: "0.25em",
  textTransform: "uppercase",
  color: colors.primary.main,
  "&::before": {
    content: '""',
    display: "block",
    width: 24,
    height: "1px",
    background: colors.primary.main,
  },
};

export const TITLE_SX = {
  fontFamily: "'Inter', system-ui, sans-serif",
  fontSize: { xs: "2.25rem", sm: "3rem", md: "3.5rem" },
  fontWeight: 700,
  letterSpacing: "-0.04em",
  lineHeight: 0.95,
  textTransform: "uppercase",
  color: colors.text.primary,
  mb: 0,
  "& span": {
    background: `
      linear-gradient(
        180deg,
        #f7cb79 0%,
        #f0b458 40%,
        #de8f2c 100%
      )
    `,
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },
};

export const BODY_SX = {
  maxWidth: "38rem",
  fontSize: "0.95rem",
  lineHeight: 1.8,
  color: colors.text.secondary,
};
